export function str(p) {
    return `${p.x},${p.y}`;
}
export function equals(p0, p1) {
    return p0.x === p1.x && p0.y === p1.y;
}
